import type { SupportedLocale } from '@/lib/utils/localization/getFlattenedLocales'
import { getCosmicFooterItems } from './cosmic/fetchFunctions/getCosmicFooterItems'
import type { CMSResult } from './types/CMSError'

export type GetFooterItemsProps = {
  locale: SupportedLocale
}

export const getFooterItems = async ({
  locale,
}: GetFooterItemsProps): Promise<CMSResult<
  ReturnType<typeof getCosmicFooterItems>
> | null> => {
  try {
    const cosmicFooterItems = await getCosmicFooterItems({
      locale,
    })

    if (!cosmicFooterItems) {
      return {
        error: {
          code: 'COSMIC_FOOTER_DATA_MISSING',
          message:
            'We were unable to load the footer content. Please try refreshing the page.',
          source: 'cosmic',
          timestamp: new Date().toISOString(),
        },
      }
    }

    return cosmicFooterItems
  } catch (error) {
    const errorMessage = error instanceof Error ? error.message : String(error)
    const errorDetails = {
      code: 'COSMIC_FOOTER_FETCH_FAILED',
      message:
        'We encountered an issue while loading the page footer. Please try again later.',
      source: 'cosmic' as const,
      details: errorMessage,
      timestamp: new Date().toISOString(),
    }

    console.error('COSMIC: Error fetching cosmic footer items:', errorDetails)
    return { error: errorDetails }
  }
}
